import React from 'react';
// import { Backdrop, CircularProgress, Box, Typography } from '@mui/material';

// const Loading = ({ showLoadingBar, message = "Loading..." }) => {
//     return (
//         <Backdrop open={Boolean(showLoadingBar)}>
//             <Box>
//                 <CircularProgress
//                     size={50}
//                     thickness={4}
//                 />
//             </Box>

//             {message && (
//                 <Typography variant="h6">
//                     {message}
//                 </Typography>
//             )}
//         </Backdrop>
//     );
// };

// export default Loading;

import { Backdrop, CircularProgress, Typography } from '@mui/material';

const Loading = ({ showLoadingBar, message = "Loading..." }) => {

    return (
        <Backdrop 
            open={Boolean(showLoadingBar)} 
            // sx is safer here to ensure it overrides any environment-specific CSS
            sx={{ 
                zIndex: (theme) => theme.zIndex.drawer + 1000,
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                color: 'primary.main', // Forces the color on the loader and text
            }}
        >
            <CircularProgress size={50} thickness={4} color="inherit" />
            
            {message && (
                <Typography 
                    variant="h6" 
                    sx={{ 
                        fontWeight: 500,
                        color: 'primary.main'
                    }}
                >
                    {message}
                </Typography>
            )}
        </Backdrop>
    );
};

export default Loading;